import React from 'react';
import { Check, Megaphone, ClipboardList, ArrowLeftRight, Bell, Coffee, CalendarCheck } from 'lucide-react';
import { OTHER_FEATURES } from './landingData';

const ICON_MAP = {
  megaphone: <Megaphone size={22} className="text-orange-500" />,
  clipboard: <ClipboardList size={22} className="text-orange-500" />,
  arrows:    <ArrowLeftRight size={22} className="text-orange-500" />,
  bell:      <Bell size={22} className="text-orange-500" />,
  coffee:    <Coffee size={22} className="text-orange-500" />,
  calendar:  <CalendarCheck size={22} className="text-orange-500" />,
};

export function OtherFeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-white" aria-label="Other Features">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        <h2
          className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 md:mb-10"
          style={{ fontFamily: 'Manrope' }}
        >
          Other Features
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {OTHER_FEATURES.map((feat) => (
            <div
              key={feat.title}
              className="bg-white border border-slate-200 rounded-2xl p-7 hover:shadow-md transition-shadow duration-200"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-lg bg-orange-50 border border-orange-100 flex items-center justify-center flex-shrink-0">
                  {ICON_MAP[feat.iconKey]}
                </div>
                <h3 className="text-lg font-bold text-slate-900">{feat.title}</h3>
              </div>
              <p className="text-slate-500 text-sm leading-relaxed mb-5">{feat.desc}</p>
              <div className="border-t border-slate-100 pt-4 space-y-2.5">
                {feat.bullets.map((b) => (
                  <div key={b} className="flex items-center gap-2.5">
                    <Check size={14} className="text-orange-500 flex-shrink-0" strokeWidth={3} />
                    <span className="text-slate-700 text-sm">{b}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
